import React, { useRef, useState } from 'react'
import { Input, Modal, notification } from 'antd'
import CustomButton from '../CustomButton'
import { createTemplate } from '../../redux/actions/templateaction'

const LINK_PLACEHOLDER = '{{link}}'

const CreateTemplateModal = ({ visible, onClose, organizationid }) => {
  const [name, setName] = useState('')
  const [message, setMessage] = useState('')
  const [saving, setSaving] = useState(false)
  const textareaRef = useRef(null)

  const reset = () => {
    setName('')
    setMessage('')
  }

  const cancel = () => {
    reset()
    onClose()
  }

  const insertLink = () => {
    const el = textareaRef.current?.resizableTextArea?.textArea
    if (!el) {
      setMessage((prev) => (prev ? `${prev} ${LINK_PLACEHOLDER}` : LINK_PLACEHOLDER))
      return
    }
    const start = el.selectionStart ?? message.length
    const end = el.selectionEnd ?? message.length
    const next = message.slice(0, start) + LINK_PLACEHOLDER + message.slice(end)
    setMessage(next)
    requestAnimationFrame(() => {
      el.focus()
      const cursor = start + LINK_PLACEHOLDER.length
      el.setSelectionRange(cursor, cursor)
    })
  }

  const save = async () => {
    if (name.trim() === '' || message.trim() === '') {
      notification.error({
        message: "Name and message can't be empty.",
        duration: 3,
      })
      return
    }
    if (!organizationid) {
      notification.error({
        message: 'No organization context. Please refresh.',
        duration: 3,
      })
      return
    }
    setSaving(true)
    const payload = {
      name,
      message,
      organizationid,
      type: message.includes(LINK_PLACEHOLDER) ? 'link' : 'text',
    }
    const res = await createTemplate(payload)
    setSaving(false)
    if (res?.data?.success) {
      notification.success({ message: 'Template created.', duration: 2 })
      reset()
      onClose()
    }
  }

  const charCount = message.length

  return (
    <Modal
      className='campaignmessage'
      title=''
      open={visible}
      width={908}
      onCancel={cancel}
      centered
      footer={[]}
    >
      <h1>Create Template</h1>

      <p>Title</p>
      <Input
        className='title'
        value={name}
        onChange={(e) => {
          if (e.target.value.length <= 125) setName(e.target.value)
        }}
        style={{
          borderColor: name.length === 125 ? 'red' : '',
          borderWidth: name.length === 125 ? '2px' : '1px',
        }}
      />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '12px' }}>
        <p style={{ marginBottom: 0 }}>Message</p>
        <button
          type='button'
          onClick={insertLink}
          style={{
            backgroundColor: '#2563eb',
            color: '#fff',
            border: 'none',
            padding: '6px 12px',
            borderRadius: '4px',
            fontSize: '13px',
            cursor: 'pointer',
          }}
        >
          Insert Link
        </button>
      </div>

      <Input.TextArea
        ref={textareaRef}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={6}
        placeholder='Type your SMS message. Use the Insert Link button to control where the tracking URL appears.'
        style={{ marginTop: '6px' }}
      />
      <p style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
        {`Use ${LINK_PLACEHOLDER} as a placeholder for the tracking URL. ${charCount} chars (SMS limit: 160).`}
      </p>

      <div className='btn'>
        <CustomButton
          className='cancel'
          width={'22%'}
          style={{ marginBottom: '0px' }}
          onClick={cancel}
          text={'Cancel'}
        />
        <CustomButton
          width={'22%'}
          style={{ marginBottom: '0px' }}
          onClick={save}
          text={saving ? 'Saving...' : 'Save'}
        />
      </div>
    </Modal>
  )
}

export default CreateTemplateModal
